const { REACT_APP_DEFAULT_THEME } = process.env;
export const CURRENT_THEME = REACT_APP_DEFAULT_THEME;
